import React from 'react';
import { Link } from 'react-router-dom';
import { LifeBuoy, Mail, Phone, MessageSquare, HelpCircle, ArrowRight } from 'lucide-react';

const quick = [
  { q: 'How do I upload documents?', a: 'Go to Documents, pick a category, then click Upload. Files stay private to your account.' },
  { q: 'When are renewal reminders sent?', a: 'Automatically at 60, 30, 14 and 7 days before your policy renewal date.' },
  { q: 'Can I edit an existing policy?', a: 'Open My Policies, click the policy and update premium, renewal date or cover.' },
  { q: 'Is my data safe?', a: 'Your data is only used to generate your quote and manage your policies. We never sell personal data.' },
];

export default function Support() {
  return (
    <div>
      <div className="mb-6">
        <span className="eyebrow">Support</span>
        <h1 className="mt-2 text-3xl font-bold text-[#0b1f3a]">Help & Support</h1>
        <p className="text-slate-600 text-sm mt-1">Find quick answers or contact our English-speaking team.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        <ChannelCard icon={Mail} title="Email" text="hello@easyspanishinsurance.com" />
        <ChannelCard icon={Phone} title="Phone" text="+34 951 000 000" />
        <ChannelCard icon={MessageSquare} title="In-app messages" text="Reply times: same business day" to="/dashboard/messages" />
      </div>

      <div className="mt-8 bg-white border border-slate-200 rounded-2xl p-6">
        <h2 className="font-semibold text-[#0b1f3a] mb-3 flex items-center gap-2"><HelpCircle size={18} /> Quick answers</h2>
        <div className="space-y-3">
          {quick.map((q) => (
            <div key={q.q} className="border border-slate-200 rounded-xl p-4">
              <p className="font-semibold text-[#0b1f3a] text-sm">{q.q}</p>
              <p className="text-sm text-slate-600 mt-1 leading-relaxed">{q.a}</p>
            </div>
          ))}
        </div>
        <Link to="/faq" className="btn-outline mt-5">Browse all FAQs <ArrowRight size={14} /></Link>
      </div>
    </div>
  );
}

function ChannelCard({ icon: Icon, title, text, to }) {
  const inner = (
    <div className="bg-white border border-slate-200 rounded-2xl p-5 card-lift h-full">
      <span className="icon-tile mb-3"><Icon size={18} /></span>
      <p className="font-semibold text-[#0b1f3a]">{title}</p>
      <p className="text-sm text-slate-600 mt-1">{text}</p>
    </div>
  );
  return to ? <Link to={to}>{inner}</Link> : inner;
}
